<script setup>
defineProps(['species', 'iconClass'])
</script>

<template>
  <!--  https://icon-sets.iconify.design/noto/-->
  <svg xmlns="http://www.w3.org/2000/svg" :class="iconClass" viewBox="0 0 128 128">
    <template v-if="species === 'Cat'">
      <path
        fill="#ffc022"
        d="M114.67 70.19C112.71 44.22 94.44 26.3 64 26.3S15.25 45.33 13.45 71.31c-1.05 15.14 4.58 28.63 15.91 36.32c7.46 5.07 17.88 7.88 34.77 7.88c17.18 0 27.03-3.71 34.49-8.73c12.43-8.35 17.18-21.67 16.05-36.59"
      />
      <path
        fill="#ffc022"
        d="M53.72 42.6C46.3 23.4 30.1 10.34 23.87 8.39c-2.35-.74-5.3-.81-6.63 1.35c-3.36 5.45-7.66 22.95 1.85 47.78z"
      />
      <path
        fill="#ffd1d1"
        d="M36.12 34.21c1.54-1.29 2.29-2.55.6-5.16c-2.62-4.05-7.33-8.78-9.16-10.23c-3-2.38-5.32-3.18-6.21.65c-1.65 7.08-1.52 16.69.25 21.99c.62 1.87 2.54 2.86 4.02 1.57z"
      />
      <path
        fill="#ff9b31"
        d="M54.12 45.02c1.13.96 3.42.82 4.75-.72c1.61-1.87 3.29-8.17 2.24-17.91c-4.67.17-9.09.84-13.21 1.97c3.33 5.46 4.13 14.88 6.22 16.66m19.76 0c-1.13.96-3.42.82-4.75-.72c-1.61-1.87-3.29-8.17-2.24-17.91c4.67.17 9.09.84 13.21 1.97c-3.33 5.46-4.13 14.88-6.22 16.66"
      />
      <path
        fill="#ffc022"
        d="M79.9 29.22c8.08-12.41 19.38-20.75 24.07-22.24c2.32-.74 5.02-.62 6.34 1.55c3.32 5.45 6.13 22.24-.42 45.75L85.96 42.74z"
      />
      <path
        fill="#ffd1d1"
        d="M97.55 38.23c2.43 2.43 4.41 4.06 5.84 5.61c.95 1.03 2.69.56 2.97-.82c2.45-11.8 1.67-21.86 0-24.5c-.8-1.26-2.29-1.59-3.65-1.13c-2.44.81-8.66 5.45-13.05 12.22c-.51.79-.32 1.85.46 2.38c1.58 1.07 4.34 3.14 7.43 6.24"
      />
      <path
        d="M55.67 77.75c-.05-3.08 4.37-4.55 8.54-4.62c4.18-.07 8.68 1.29 8.73 4.37c.05 3.08-5.22 7.13-8.54 7.13c-3.31 0-8.67-3.81-8.73-6.88"
      />
      <path
        fill="none"
        stroke="#9e9e9e"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="3"
        d="M6.7 71.03c.34.41 4.41.35 14.36 5.07M2.9 82.86s6.42-2.24 17.46-.28M8.81 92.29s2.74-1.38 12.67-2.25m99.39-22.53s-3.41.33-13.94 6.34m15.49 4.64s-5.09-.36-16.05 1.97m14.08 8.59s-4.83-1.71-14.78-2.25"
      />
      <path
        fill="#000200"
        d="M96.09 66.37c-.34 5.51-3.76 8.54-7.65 8.54s-7.04-3.88-7.04-8.66s3.28-8.71 7.65-8.47c5.07.29 7.32 4.09 7.04 8.59M46 65.81c.78 5.61-1.58 9.03-5.49 9.82c-3.91.79-7.26-1.84-8.23-6.64c-.98-4.81.9-9.32 5.34-9.97c5.15-.75 7.74 2.2 8.38 6.79"
      />
      <path
        d="M44.99 85.16c-2.57 1.67.47 5.54 2.25 6.85c1.78 1.31 4.98 2.92 9.67 2.44c5.54-.56 7.13-4.69 7.13-4.69s1.97 4.6 8.82 4.79c6.95.19 9.1-3.57 10.04-4.69c.94-1.13 1.88-4.04.28-5.16c-1.6-1.13-2.72.28-4.41 2.63c-1.69 2.35-5.16 3.66-8.54 2.06s-3.57-7.04-3.57-7.04l-4.79.28s-.75 4.69-2.91 6.19s-7.32 1.88-9.48-1.41c-.95-1.46-2.33-3.66-4.49-2.25"
      />
    </template>
    <template v-if="species === 'Dog'">
      <path
        fill="#ffeac8"
        d="M63.76 19.97c-29.09-.75-38.51 21.77-39.23 30.22c-.56 6.57-3.38 30.6 10.32 46.74c7.07 8.33 18.4 12.48 30.41 12.2c12.11-.28 23.05-2.69 30.41-12.39c12.39-16.33 11.07-40.73 9.39-48.62c-1.58-7.34-7.71-27.29-41.3-28.15"
      />
      <path
        fill="#d27856"
        d="M96.82 64.43c1.03 7.81-2.36 15.26-11.29 15.79c-8.17.49-13.21-4.72-13.61-12.39c-.41-7.86 3.89-15.17 10.72-15.92c7.21-.79 13.16 4.71 14.18 12.52M18.9 26.72s-9.83 3.85-12.2 9.57c-3.19 7.7-1.72 22.98 0 28.91c1.69 5.82 6.19 11.83 13.14 11.64s13.05-7.23 15.2-16.42c2.16-9.2 2.63-24.96 3.28-27.78s1.78-5.07 1.78-5.07s-8.63-8.36-21.2-.85m82.31-1.22s13.33.47 16.52 1.88s6.1 7.79 5.82 16.33s-.84 22.35-5.16 27.12c-3.57 3.94-10.79 4.22-14.83-.66s-6.57-13.14-7.51-18.49c-.94-5.35-2.53-12.29-3.57-15.39c-1.03-3.1-3.57-9.29-4.88-10.7c-1.32-1.4 1.31-2.72 13.61-.09"
      />
      <path
        fill="#865b51"
        d="M29.97 22.31c-7.23-.46-19.15 5.26-21.59 11.17S7.37 58.57 9.42 64.17c2.16 5.91 6.66 13.33 14.45 6.95s9.85-22.43 10.61-27.59c.75-5.16 1.78-11.45 2.91-12.76c1.13-1.31 2.72-3.19 2.72-3.19s-1.22-4.71-10.14-5.27m72.83-1.22c6.79.47 14.17 3 16.89 8.92c2.72 5.91 1.69 19.9.66 26.56s-3.47 13.61-9.57 12.86s-9.2-9.01-11.07-16.8c-1.88-7.79-3.85-15.58-6.29-21.21c-1.47-3.4-6.57-5.91-6.57-5.91s2.25-5.36 15.95-4.42"
      />
      <path
        fill="#2f2f2f"
        d="M50.5 67.69c-.4 3.42-2.16 6.18-5.98 5.78c-2.71-.29-4.53-3.52-4.13-6.95c.4-3.42 1.59-5.88 4.79-5.82c4.97.09 5.72 3.56 5.32 6.99m39.24-.96c.16 3.44-1.2 6.38-5.17 6.67c-3.45.25-5.22-2.74-5.37-6.18c-.16-3.44 1.55-6.2 4.84-6.61c4.27-.55 5.54 2.68 5.7 6.12M75.12 84.07c.16 3.44-2.16 6.66-9.39 6.57c-7.04-.09-9.6-2.94-9.76-6.38c-.16-3.44 3.84-6.53 9.57-6.66c7.89-.2 9.42 3.02 9.58 6.47"
      />
      <path
        fill="#e94b8c"
        d="M59.16 97.96s.85 8.17 1.69 10.61c1.78 5.16 9.28 4.3 10.61-.56c1.13-4.13.38-11.26.38-11.26l-6.66-.94z"
      />
      <path
        fill="#ef87b2"
        d="M65.96 100.68c-1.17.05-1.13 1.13-1.13 3.61c0 2.49.14 3.99 1.27 3.94c1.13-.05.99-1.97.99-3.75s.09-3.85-1.13-3.8"
      />
      <path
        fill="#2f2f30"
        d="M50.15 90.21c-1.35 1.99 1.27 3.75 3.43 5.21c2.16 1.45 4.78 3.66 7.88 3.61c3.47-.05 4.41-2.39 4.41-2.39s1.13 2.77 6.05 2.25c2.63-.28 5.87-3.23 6.85-3.89c1.88-1.27 4.13-2.86 3.14-4.18c-1.13-1.51-3.52.52-5.96 1.78c-2.44 1.27-3.28 1.88-5.11 1.88s-3.1-.75-3.19-3.8c-.08-2.49-.05-2.96-.05-2.96h-4.18s.14 2.63.14 3.38c0 1.97-1.03 2.82-3 2.91c-1.97.09-4.08-1.55-5.12-2.16c-1.02-.6-4.21-3.23-5.29-1.64"
      />
    </template>
    <template v-if="species === 'Rabbit'">
      <path
        fill="#b5c2c8"
        d="M61.32 52.97s1.31-.28 3.1-.28s3.57.47 3.57.47s4.04-5.73 4.97-13.98s.94-17.36 3.85-24.5c2.91-7.13 7.6-9.67 12.01-9.01s14.12 8.31 11.36 28.72c-1.98 14.54-12.59 21.46-11.27 31.9c1.13 8.92 6.48 15.77 8.73 20.46c2.25 4.69 6.66 12.76-.94 23.56c-7.8 11.07-24.59 13.33-32.29 13.14c-7.7-.19-20.52-.85-30.88-9.76c-4.69-4.04-7.6-9.48-7.32-17.64c.28-8.17 6.85-16.52 9.1-20.65s4.97-7.13 4.88-11.26c-.09-4.13-5.91-15.77-7.51-23.56c-1.6-7.79-7.32-32.66 13.05-36.13c11.16-1.9 8.63 18.21 10.98 31.07c2.36 12.85 4.61 17.45 4.61 17.45"
      />
      <path
        fill="#feaca9"
        d="M78.68 54.47c4.42 2.92 7.39-3.7 8.45-6.38c1.6-4.04 5.16-11.26 5.35-19.99c.15-7.14-.28-13.23-5.44-13.05c-5.16.19-4.97 8.54-4.88 11.36c.14 4.32-.95 10.55-2.06 14.92c-1.62 6.35-5.83 10.23-1.42 13.14M44.99 14.11c-4.5-.56-7.13 6.1-6.57 12.95s2.82 17.36 5.35 22.15c2.53 4.79 3.85 5.91 6.95 5.07c3.1-.84.94-6.38.66-8.26c-.28-1.88-2.63-13.98-2.63-19.52s.81-11.82-3.76-12.39"
      />
      <path
        fill="#fff"
        d="M64.98 60.19c4.51 0 2.32 8.85 3.45 13.73c1.13 4.88 5.35 9.2 8.66 12.67c4.15 4.36 9.1 13.63 8.17 19.36c-.94 5.73-3.87 14.22-20.74 14.03c-14.59-.16-20.93-4.6-21.21-15.09c-.26-9.8 6.41-16.68 8.8-18.65s5.84-5.42 7.39-9.43c1.55-4.01 1.97-8.09 2.11-10.28c.13-2.18-.36-6.34 3.37-6.34"
      />
      <path
        fill="#2f2f2d"
        d="M52.45 75.68c0 3.75-.77 6.76-4.36 6.76c-2.6 0-3.87-2.69-3.87-6.44s1.34-6.58 4.15-6.37c2.84.21 4.08 2.3 4.08 6.05m31.6.77c0 3.75-.63 6.55-4.22 6.55c-2.6 0-3.8-3.15-3.8-6.9s.77-5.91 3.59-5.91c2.75 0 4.43 2.51 4.43 6.26"
      />
      <path
        fill="#ffd792"
        d="m64.93 107.19l-4.97 2.16s.02 3.36 2.28 3.33c1.7-.03 2.27-1.06 2.27-1.06s.85 1.09 2.76 1.06c2.26-.04 2.05-2.87 2.05-2.87z"
      />
      <path
        fill="#fee2b3"
        d="m69.25 102.47l-9.9 1.17s.47 5.73.68 6.22s.56 1.13 2.11 1.27c1.55.14 2.39-1.06 2.39-1.06s.57 1.11 2.22 1.25c1.02.09 2.43-.3 2.6-1.02c.29-1.2.19-2.26.18-4.03c-.01-1.56-.28-3.8-.28-3.8"
      />
      <path
        fill="#2c2c2c"
        d="M64.32 92.85s4.67-5.86 6.29-3.85c1.9 2.36-4.88 7.13-4.88 7.13s.24 3.7.55 3.97c2.75 2.36 5.07-.32 5.35-.6c.28-.28 1.9-1.51 2.96-.18s-1.02 5.95-5.14 6.23c-4.12.28-5-2.04-5-2.04s-.63 2.64-5.35 2.43s-5.31-5.35-4.26-6.12c1.06-.77 1.42-.71 3.59 1.13c1.37 1.16 3.87.18 4.01-1.09c.07-.6-.04-3.77-.04-3.77s-7.6-4.65-5.53-7.11c2.09-2.46 7.45 3.87 7.45 3.87"
      />
      <path
        fill="#838584"
        d="M36.35 95.53c-.19 0-.38-.04-.57-.11c-.04-.01-3.87-1.56-8.25-1.44c-4.76.14-7.21.83-7.23.83c-.8.23-1.63-.23-1.86-1.02c-.23-.79.22-1.62 1.02-1.86c.11-.03 2.78-.8 7.98-.95c5.05-.16 9.31 1.59 9.49 1.66c.77.32 1.13 1.19.81 1.96c-.24.58-.8.93-1.39.93m-16.18 10.18c-.44 0-.88-.19-1.18-.57c-.52-.65-.41-1.59.24-2.11c.14-.11 3.49-2.75 7.84-3.85c4.27-1.08 9.14-.76 9.34-.75c.83.06 1.45.77 1.39 1.6c-.06.83-.76 1.47-1.6 1.39c-.04 0-4.61-.3-8.4.66c-3.73.94-6.68 3.26-6.71 3.29c-.27.23-.6.34-.92.34m4.5 8.02c-.38 0-.77-.15-1.06-.44a1.49 1.49 0 0 1 0-2.12c.1-.1 2.58-2.58 4.65-4.17c2.17-1.67 6.72-3.38 6.91-3.45c.78-.29 1.64.1 1.93.88c.29.78-.1 1.64-.88 1.93c-1.2.45-4.63 1.87-6.14 3.02c-1.91 1.47-4.33 3.88-4.36 3.91c-.28.3-.67.44-1.05.44m65.98-17.78c-.66 0-1.27-.44-1.45-1.11c-.22-.8.25-1.62 1.05-1.84c.18-.05 4.39-1.18 8.46-1.32c4.43-.15 8.1 1.01 8.25 1.06a1.497 1.497 0 0 1-.91 2.85c-.03-.01-3.34-1.04-7.24-.92c-3.71.12-7.74 1.21-7.78 1.22c-.12.04-.25.06-.38.06m15.39 8.31c-.33 0-.67-.11-.95-.34c-.01-.01-1.96-1.54-5.91-2.47c-3.82-.9-7.61-.58-7.65-.58c-.81.07-1.55-.54-1.62-1.36c-.07-.83.54-1.55 1.36-1.62c.17-.02 4.31-.36 8.59.64c4.7 1.1 7.04 2.99 7.13 3.07c.64.53.73 1.47.21 2.11c-.3.36-.73.55-1.16.55m-2.68 7.36c-.35 0-.7-.12-.98-.37c-.03-.02-2.75-2.37-5.29-3.58c-2.43-1.15-5.96-1.22-5.99-1.22a1.5 1.5 0 0 1 .02-3h.02c.17 0 4.21.07 7.24 1.5c2.92 1.39 5.85 3.92 5.97 4.02c.63.54.69 1.49.15 2.12c-.3.36-.72.53-1.14.53"
      />
    </template>
    <!--    <template v-if="species === 'Bird'">-->
    <!--      <path-->
    <!--        fill="#fe8f01"-->
    <!--        d="m78.49 99.47l-5.35.56s-.57 13.78.99 16.75c1.55 2.96 6.41 3.68 10.56 3.24c3.94-.42 4.22-2.96 3.66-4.79c-.56-1.83-3.1-3.52-5.21-4.79c-1.71-1.02-2.11-4.36-2.39-9.15c-.15-2.52-2.26-1.82-2.26-1.82m-22.24.33l-8.12.52s.23 6.62-.19 9.15c-.51 3.05-6.08 3.2-7.74 5.54c-1.27 1.78.31 4.92 3.85 5.35c2.35.28 8.54.66 10.65-3.14c1.84-3.33 1.55-17.42 1.55-17.42"-->
    <!--      />-->
    <!--      <path-->
    <!--        fill="#ffb903"-->
    <!--        d="M29.97 50.06s-3.94-16.33 9.39-31.72s37.54-12.96 49.74.37S98.86 51 98.86 51s4.88 9.2 12.39 15.39c5.12 4.23 14.27 11.07 12.2 15.39c-2.06 4.32-4.13 3.38-7.7 3.19s-14.27-5.44-14.27-5.44s-2.44 26.65-36.04 27.41s-38.85-27.23-38.85-27.23s-13.89 4.32-16.14 4.32s-6.18-.99-6.01-5.44c.19-4.69 9.2-9.2 12.95-12.76c3.76-3.57 9.95-9.2 12.58-15.77"-->
    <!--      />-->
    <!--      <ellipse-->
    <!--        cx="81.97"-->
    <!--        cy="36.92"-->
    <!--        fill="#2e302d"-->
    <!--        rx="5.27"-->
    <!--        ry="4.59"-->
    <!--        transform="rotate(-86.084 81.972 36.919)"-->
    <!--      />-->
    <!--      <ellipse-->
    <!--        cx="46.36"-->
    <!--        cy="37.06"-->
    <!--        fill="#2e302d"-->
    <!--        rx="4.59"-->
    <!--        ry="5.27"-->
    <!--        transform="rotate(-7.607 46.349 37.068)"-->
    <!--      />-->
    <!--      <path-->
    <!--        fill="#fe8f01"-->
    <!--        d="M63.99 40.34c-7.04.16-9.15 3.64-9.15 5.91c0 2.67 6.76 8.59 9.01 8.59s9.15-6.19 9.22-8.59c.07-2.25-2.74-6.05-9.08-5.91m58.12 43.57s-2.37 3.03-6.03 3.31c-3.95.3-10.42-.7-14.36-4.22S96.8 71.88 98.2 70.33c1.41-1.55 3.52 4.96 9.15 8.45c6.1 3.77 14.76 5.13 14.76 5.13M18.52 79.9c5.34-2.41 13.06-11.8 13.94-10.84c1.55 1.69-.03 9.6-4.79 13.66c-4.79 4.08-12.01 4.69-18.07 2.16c-3.32-1.39-4.41-2.91-4.88-3.85c-1.13-2.27 6.62 2.11 13.8-1.13"-->
    <!--      />-->
    <!--    </template>-->
    <template v-if="species === 'Bird'">
      <path
        fill="#feba02"
        d="M40.01 95.48s2.44 10.04 2.06 11.45c-.38 1.41-7.32 2.53-11.36 4.6c-2.65 1.36-6.92 4.39-4.32 6.84c1.41 1.33 5.35-2.03 17.18-2.71c12.01-.69 14.13.29 13.51-2.25c-.61-2.53-3.8-2.82-6.48-3.94c-.89-.37-1.92-.96-2.35-1.6c-.41-.61.19-10.98.19-10.98z"
      />
      <path
        fill="#feba02"
        d="M62.16 102.52s.28 10.15.28 10.8c0 .95-2.32 2.09-5.77 2.86c-3.45.77-10.28 2.05-10.37 6.42c-.06 2.69 13.12-.95 20.65-.84s12.36 1.1 12.01-2.06c-.28-2.53-4.2-3.68-6.31-4.14c-2.11-.46-3.07-1.49-3.13-2.75c-.04-.82.14-10.07.14-10.07z"
      />
      <linearGradient
        id="notoParrot0"
        x1="46.854"
        x2="65.857"
        y1="97.057"
        y2="33.649"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".136" stop-color="#79da88" />
        <stop offset=".304" stop-color="#57cd75" />
        <stop offset=".634" stop-color="#19b553" />
        <stop offset=".791" stop-color="#01ab46" />
      </linearGradient>
      <path
        fill="url(#notoParrot0)"
        d="m41.89 8.01l9.06-.61s5.04 1.63 9.83 8.57c6.36 9.23 5.52 26.11 5.52 26.11l17.46 46.55l2.11 15.39s-15.62 2.46-30.92.47c-18.02-2.35-36.6-18.68-36.32-43.08c.28-24.4 19.62-47.96 19.62-47.96z"
      />
      <path
        fill="#ffd51d"
        d="M21.15 16.93s-6.95 2.16-8.92 9.95S13.55 41.92 15 42.41c.56.19 2.3-3.33 2.3-3.33s2.44 2.82 3.66 3.47c1.22.66 1.83 1.15 2.91 1.08c2.11-.14 5.21-6.29 5.12-10.42l1.08-20.23z"
      />
      <path
        fill="#ff2b23"
        d="M29.85 28.09s8.47-1.41 11.85-4.32s7.32-5.54 8.63-10.79c.8-3.2.84-5.44.84-5.44S39.36.69 28.66 6.32S20.49 19.6 20.49 19.6z"
      />
      <path
        fill="#ff600d"
        d="M29.5 29.22s-6.85 4.04-7.6 4.6s-3.2 1.78-4.32 2.72c-1.78 1.5-3.38 4.88-2.72 5.73c.66.84 1.6-1.78 4.22-3.38s7.13-4.13 8.35-4.79c1.22-.66 1.6-1.03 1.6-1.03z"
      />
      <path
        fill="#a02a1b"
        d="M31.83 27.46c.47-.99.68-3.26-2.51-7.25c-3.75-4.69-9.01-4.88-9.01-4.88l-.56 1.88l5.82 5.82L28.8 30s2.06-.5 3.03-2.54"
      />
      <path
        fill="#ec80af"
        d="M15.89 20.4s4.32.28 7.32 2.91c1.78 1.56 4.47 4.9 5.13 6.41s2.91-2.67 1.13-5.49s-3.91-5.65-7.85-7.02c-2.84-.98-5.54 1.41-5.73 3.19"
      />
      <path
        fill="#fbd3b3"
        d="M49.49 25.94s-3.47-8.82-10.61-8.45c-7.2.38-8.31 5.73-7.98 8.92c.38 3.69 2.82 5.73 8.45 5.54c5.64-.2 10.14-6.01 10.14-6.01"
      />
      <path
        fill="#312f2a"
        d="M44.24 24.81c0 2.28-2.48 4.32-4.74 4.32c-2.25 0-4.08-1.85-4.08-4.13s1.31-4.79 4.5-4.97c3.37-.21 4.32 2.5 4.32 4.78"
      />
      <path
        fill="#01ab46"
        d="M86.38 80.75s2.25 5.07 10.89 10.7c7.33 4.78 10.89 7.7 15.96 9.48c5.07 1.78 5.26 2.25 5.07 3.19c-.19.94-8.07 7.04-16.71 6.29c-8.63-.75-12.76-4.13-15.39-5.91s-7.6-14.36-7.6-14.36z"
      />
      <path
        fill="#b7d019"
        d="M66.34 41.84s-11.97 3.52-17.22 11.5c-4.4 6.68-4.01 18.04.47 26.47c5.54 10.42 16.99 17.83 23.09 20.65c6.1 2.82 14.45 4.22 18.11 3.85s-3.28-25.62-9.95-39.14c-6.5-13.19-14.5-23.33-14.5-23.33"
      />
    </template>
  </svg>
</template>

<style scoped></style>
